<app-report-guardian *ngIf="authService.isGranted('ROLE_GUARDIAN')" [server_user_id]="server_user_id"> </app-report-guardian>
<app-report-student *ngIf="authService.isGranted('ROLE_STUDENT')" [server_user_id]="server_user_id"> </app-report-student>
